import { useQuery, useMutation, invalidateKeys } from '../lib/query';
import { listPlaceImages, listAllPlaceImages, deletePlaceImage, bulkDeletePlaceImages, moderatePlaceImages } from '../services/placeImages';

const KEY = 'place-images';
const ALL_KEY = 'place-images-all';

export const usePlaceImages = (params) =>
  useQuery({ queryKey: [KEY, params], queryFn: () => listPlaceImages(params) });

export const useAllPlaceImages = (params) =>
  useQuery({ queryKey: [ALL_KEY, params], queryFn: () => listAllPlaceImages(params) });

export const useDeletePlaceImage = (opts = {}) =>
  useMutation({
    mutationFn: async (id) => {
      await deletePlaceImage(id);
      await moderatePlaceImages([id], true);
    },
    onSuccess: () => { invalidateKeys([KEY]); opts.onSuccess?.(); },
    onError: opts.onError,
  });

// Plain delete for the All Place Images gallery (delete only, refreshes that list).
export const useDeleteAllPlaceImage = (opts = {}) =>
  useMutation({
    mutationFn: (id) => deletePlaceImage(id),
    onSuccess: () => { invalidateKeys([ALL_KEY]); opts.onSuccess?.(); },
    onError: opts.onError,
  });

// Moderate flow: delete the selected images, then mark ALL image ids as moderated.
export const useModeratePlaceImages = (opts = {}) =>
  useMutation({
    mutationFn: async ({ deleteIds, allIds }) => {
      if (deleteIds.length) await bulkDeletePlaceImages(deleteIds);
      if (allIds.length) await moderatePlaceImages(allIds, true);
    },
    onSuccess: () => { invalidateKeys([KEY]); opts.onSuccess?.(); },
    onError: opts.onError,
  });
